import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Client Name",
  "Contact",
  "generted by",
  "Assign",
  "View",
];

const AllProjectsTable = ({ CP = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    id = getId(id);
    navigate(`/client-projects/view/${id}`);
  };

  const assignAsFarmer = (values) => {
    performRequest("POST", "/clientProject/assignAsFarmer", values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Assign as farmer successfully!");
          navigate(`/client-projects`);
        } else {
          Toast("error", "Error while assinging!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const returnClassname = (workOrder, refund) => {
    if (workOrder && !refund) {
      return "badge bg-success me-2";
    } else if (refund) {
      return "badge bg-danger me-2";
    } else if (!workOrder && !refund) {
      return "badge bg-yellow me-2";
    }
  };

  return (
    <>
      <div className="table-responsive d-none d-lg-block d-md-block">
        <table className="table table-vcenter">
          <thead>
            <tr>
              {tableHead?.map((item, index) => {
                return <th key={index}>{item}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {CP?.map((item, index) => {
              const Index = (currentPage - 1) * itemsPerPage + index + 1;
              return (
                <tr key={item?.cpNumber}>
                  <td>{Index}</td>
                  <td>
                    <span
                      className={returnClassname(
                        item?.workOrderUploaded,
                        item?.refund
                      )}
                    ></span>
                    {item?.clientName || "N/A"}
                  </td>
                  <td>
                    {item?.clientEmail || "N/A"}
                    <br />
                    <span className="text-secondary badge bg-cyan-lt">
                      {item?.clientContactNumber || "N/A"}
                    </span>
                  </td>

                  <td>{item?.generatedBy || "N/A"}</td>
                  <td>
                    <td>
                      <button
                        className="btn btn-sm px-3 btn-primary"
                        onClick={() =>
                          assignAsFarmer({ email: item.clientEmail })
                        }
                      // disabled={item?.isFarmer == 1}
                      >
                        Assign as patner
                      </button>
                    </td>
                  </td>
                  <td>
                    <CustomViewButton onClick={() => goToView(item.cpNumber)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-responsive d-block d-lg-none d-md-none">
        <table className="table table-vcenter">
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Client Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {CP?.map((item, index) => {
              const Index = (currentPage - 1) * itemsPerPage + index + 1;
              return (
                <tr key={item?.cpNumber}>
                  <td>{Index}</td>
                  <td>
                    <span
                      className={returnClassname(
                        item?.workOrderUploaded,
                        item?.refund
                      )}
                    ></span>
                    {item?.clientName || "N/A"}
                  </td>
                  <td>
                    <CustomViewButton onClick={() => goToView(item.cpNumber)} ></CustomViewButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AllProjectsTable;
